// extracted by mini-css-extract-plugin
module.exports = {"md":"TabbarSlot_md_3L8OB","ios":"TabbarSlot_ios_27FzC","tabbarBefore":"TabbarSlot_tabbarBefore_3CyjE","noTabbar":"TabbarSlot_noTabbar_2gYc5"};